import { createSelector } from 'reselect';
import { AppState } from '../store/types/Store';
import { getViewIndex } from './commonSelectors';
import { getCurrentSeason } from './seasonSelectors';

export const getLayersState = (state: AppState) => state.layers;

export const getActiveMapLayers = (state: AppState) => state.layers.activeMapLayers;

const getLayersList = (state: AppState) => state.layers.list;

export const getCurrentLayerName = createSelector(
  [getActiveMapLayers,
    getViewIndex],
  (activeMapLayers, index) => activeMapLayers[index]?.name ?? ''
);

export const getCurrentLayerId = createSelector(
  [getActiveMapLayers,
    getViewIndex],
  (activeMapLayers, index) => activeMapLayers[index]?.id ?? ''
);

export const getCurrentSeasonLayer = createSelector(
  [getLayersList, getCurrentSeason],
  (layersList, getCurrentSeason) => layersList?.[getCurrentSeason]
);
